import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import '../assets/base.css';

import Header from '../components/Header';
import Footer from '../components/Footer';

const Main = styled.main`
	padding: 0rem;
	background: #fff;
	/* .content-wrap {
		padding-top: 110px;
	} */
`;

const TemplateWrapper = ({ children, data, location }) => (
	<Main>
		<Helmet
			title="Wavey Media Group | Digital Brand Stategy 🕶️"
			link={[
				{
					rel: 'stylesheet',
					href:
						'https://fonts.googleapis.com/css?family=Work+Sans:300,400,700|Roboto:300,400,500,700|Lato:300,400,500,700'
				},
				{
					rel: 'stylesheet',
					href:
						'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css'
				},
				{
					rel: 'stylesheet',
					href:
						'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css'
				}
			]}
		/>

		<Header logo={data.logo} />
		{children()}
		<Footer logo={data.logo} />
	</Main>
);

TemplateWrapper.propTypes = {
	children: PropTypes.func
};

export const query = graphql`
	query siteMetadata {
		logo: imageSharp(id: { regex: "/logo.svg/" }) {
			sizes(quality: 100, maxWidth: 700) {
				...GatsbyImageSharpSizes
			}
		}
	}
`;

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js